import React, { useState } from 'react';

const SendEmailModal = ({ isOpen, onClose, people, onSendEmail }) => {
	const [selectedUser, setSelectedUser] = useState('');
	const [subject, setSubject] = useState('');
	const [message, setMessage] = useState('');
	const [sendToAll, setSendToAll] = useState(false);

	const handleSend = (e) => {
		e.preventDefault();
		let isSuccess = false;
		if (sendToAll) {
			const recipients = people.filter((p) => p.email).map((p) => p.id);
			isSuccess = onSendEmail({ recipients, subject, message });
		} else if (selectedUser) {
			isSuccess = onSendEmail({ recipients: [selectedUser], subject, message });
		}
		if (isSuccess) {
			handleClose();
		}
	};

	const handleClose = () => {
		setSelectedUser('');
		setSubject('');
		setMessage('');
		setSendToAll(false);
		onClose();
	};

	if (!isOpen) return null;

	return (
		<div className='fixed inset-0 flex items-center justify-center bg-gray-800 bg-opacity-75 z-50'>
			<div className='bg-white rounded-lg shadow-lg w-full max-w-lg mx-4'>
				<div className='p-6'>
					<h2 className='text-xl font-bold mb-4'>Send Email</h2>
					<form onSubmit={handleSend}>
						<div className='mb-4'>
							<label className='block text-sm font-medium text-gray-700 mb-1'>
								<input
									type='checkbox'
									checked={sendToAll}
									onChange={(e) => setSendToAll(e.target.checked)}
									className='mr-2'
								/>
								Send to all users with email
							</label>
						</div>
						{!sendToAll && (
							<div className='mb-4'>
								<label className='block text-sm font-medium text-gray-700 mb-1'>Select user</label>
								<select
									className='w-full border border-gray-300 rounded-md shadow-sm p-2 text-sm focus:ring-blue-500 focus:border-blue-500'
									value={selectedUser}
									onChange={(e) => setSelectedUser(e.target.value)}
									required
								>
									<option value=''>Select user...</option>
									{people
										.filter((p) => p.email)
										.map((user) => (
											<option key={user.id} value={user.id}>
												{user.displayName || `${user.name} ${user.surname}`} ({user.email})
											</option>
										))}
								</select>
							</div>
						)}
						<div className='mb-4'>
							<label className='block text-sm font-medium text-gray-700 mb-1'>Subject</label>
							<input
								className='w-full border border-gray-300 rounded-md shadow-sm p-2 text-sm focus:ring-blue-500 focus:border-blue-500'
								type='text'
								placeholder='Subject'
								value={subject}
								onChange={(e) => setSubject(e.target.value)}
								required
							/>
						</div>
						<div className='mb-4'>
							<label className='block text-sm font-medium text-gray-700 mb-1'>Message</label>
							<textarea
								className='w-full border border-gray-300 rounded-md shadow-sm p-2 text-sm focus:ring-blue-500 focus:border-blue-500'
								rows={6}
								placeholder='Message'
								value={message}
								onChange={(e) => setMessage(e.target.value)}
								required
							/>
						</div>
						<div className='bg-gray-50 px-6 py-3 rounded-b-lg flex justify-end space-x-3'>
							<button
								type='button'
								onClick={handleClose}
								className='px-4 py-2 bg-gray-300 text-gray-700 rounded-md text-sm hover:bg-gray-400'
							>
								Cancel
							</button>
							<button
								type='submit'
								className='px-4 py-2 bg-blue-500 text-white rounded-md text-sm hover:bg-blue-600'
								disabled={(!sendToAll && !selectedUser) || !subject || !message}
							>
								Send Email
							</button>
						</div>
					</form>
				</div>
			</div>
		</div>
	);
};

export default SendEmailModal;
